import React from "react";
import HeroBanner from "../../../reusable-components/hero_banners/HeroBanner";
import { IoReturnDownBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import TableWrapper from "../../../reusable-components/table/TableWrapper";
import H1 from "../../../reusable-components/headings/H1";

export default function RTIMonthlyRemunerationPage() {
  const navigate = useNavigate();

  let employeeDetails = [
    {
      name: "Shri, Janga Bdr. Subba",
      designation: "Chairman",
      levelPayMatrix: "",
    },
    {
      name: "Shri, Tshering Ongda, IRS",
      designation: "Managing Director",
      levelPayMatrix: "Level 13 (GOI)",
    },
    {
      name: "Shri, Kishore Shrestha ",
      designation: "General Manager",
      levelPayMatrix: "Level 20 (GOS)",
    },
    {
      name: "Mrs, Indira Pillai  ",
      designation: "Additional L.O.",
      levelPayMatrix: `Level 20 (GOS) `,
    },
    {
      name: "Shri, Arun Gurung  ",
      designation: "DY. General Manager-I",
      levelPayMatrix: `Level 19 (GOS)`,
    },
    {
      name: "Shri, Durga Bdr. Manger ",
      designation: " DY. General Manager II",
      levelPayMatrix: `Level 19 (GOS)`,
    },
    {
      name: "Shri, Binod Ghatani",
      designation: " DY. General Manager II",
      levelPayMatrix: `Level 19 (GOS)`,
    },
    {
      name: "Mrs, Rinzing Ongmu Bhutia",
      designation: "Assistant Manager -I",
      levelPayMatrix: `Level 15 (GOS)`,
    },
    {
      name: "Mrs. Meera Dural",
      designation: "Assistant Manager -II",
      levelPayMatrix: `Level 15 (GOS)`,
    },
    {
      name: "Ms. Phup Lhamu Bhutia",
      designation: "Jr. Manager-I",
      levelPayMatrix: `Level 14 (GOS)`,
    },
    {
      name: "Mrs. Shanti Maya Subba",
      designation: "Jr. Manager-II",
      levelPayMatrix: `Level 14 (GOS)`,
    },
    {
      name: "Mrs. Pempa Lhamu Tamang",
      designation: "Jr. Manager-III",
      levelPayMatrix: `Level 14 (GOS)`,
    },
    {
      name: "Mrs. Kabita Sherpa",
      designation: "Sr. O.A-I",
      levelPayMatrix: `Level 11 (GOS)`,
    },
    {
      name: "Mrs. Sanju Rai",
      designation: "Sr. O.A-II",
      levelPayMatrix: `Level 11 (GOS)`,
    },
    {
      name: "Mrs. Chum Paden ",
      designation: "Sr. O.A-III",
      levelPayMatrix: `Level 11 (GOS)`,
    },
    {
      name: " Mrs. Tashi Ongmu Bhutia ",
      designation: "Sr. O.A-IV",
      levelPayMatrix: `Level 11 (GOS)`,
    },
    {
      name: "Mrs. Tirtha Maya Tamang",
      designation: "O.A-I",
      levelPayMatrix: `Level 9 (GOS)`,
    },
    {
      name: "Mr. Yapching Bhutia",
      designation: "O.A-II",
      levelPayMatrix: `Level 9 (GOS)`,
    },
    {
      name: "Mr.Tenzing Dorjee Lachenpa",
      designation: "O.A - III",
      levelPayMatrix: `Level 9 (GOS)`,
    },
    {
      name: "Mr. Prem Kr. Pradhan",
      designation: "Jr. Driver",
      levelPayMatrix: `Level 2 (GOS)`,
    },
    {
      name: "Mr. Ney Tsh. Lepcha",
      designation: "Jr. Driver",
      levelPayMatrix: `Level 2 (GOS)`,
    },
    {
      name: "Mr. Naresh Citury",
      designation: "Peon ",
      levelPayMatrix: `Level 4 (GOS)`,
    },
    {
      name: "Mr. Samphey Bhutia",
      designation: "Peon ",
      levelPayMatrix: `Level 4 (GOS)`,
    },
    {
      name: "Smt. Rekha Devi Ram",
      designation: "Safaikarmachari/ peon",
      levelPayMatrix: `Level 4 (GOS)`,
    },
    {
      name: "Mrs. Krishna Manger",
      designation: "Jr. Safaikarmachari/ Peon",
      levelPayMatrix: `Level 1 (GOS)`,
    },
    {
      name: "Mr. Mani Kr. Chettri",
      designation: "Jr.Driver",
      levelPayMatrix: `Level 2 (GOS)`,
    },
    {
      name: "Mr. Dawa Lepcha",
      designation: "Jr.Driver (Muster Roll)",
      levelPayMatrix: `Muster Roll`,
    },
    {
      name: "Mr. Ganga Hang Limboo",
      designation: "Jr. Driver",
      levelPayMatrix: "Level 2 (GOS)",
    },
    {
      name: "Mr. Tahang Limboo",
      designation: "Peon",
      levelPayMatrix: "Level 4 (GOS)",
    },
  ];
  return (
    <>
      <header>
        <HeroBanner>
          <div className="absolute left-10 md:left-14 lg:left-1/5 right-10 md:right-14 lg:right-10 top-[40%]">
            <div className="text-center">
              <H1> Monthly Remuneration Details</H1>
            </div>
          </div>
        </HeroBanner>
      </header>

      <section className="lg:mx-20 lg:my-10">
        <div className="flex justify-start" onClick={() => navigate("/rti")}>
          <div className="   flex justify-end items-center gap-2  p-1 md:px-2.5 md:py-1.5  cursor-pointer underline underline-offset-2 hover:text-secondary ">
            <IoReturnDownBack />
            <span>back to RTI page</span>
          </div>
        </div>

        <div className="mx-6 my-4 lg:mx-0 lg:my-0">
          <p className="font-semibold  text-center pb-3 text-base md:text-xl underline underline-offset-2">
            Monthly remuneration of Officers and staff of Sikkim SC ST & OBC
            Development Corporation Ltd. (SABCCO )
          </p>
          <section className="my-10">
            <div className=" border border-slate-200 overflow-x-auto">
              <table className=" divide-y divide-slate-200">
                <thead className="bg-white text-sm ">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left font-semibold text-slate-900 "
                    >
                      S.No.
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left font-semibold text-slate-900 "
                    >
                      Name of Officers and Staff
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left font-semibold text-slate-900 "
                    >
                      Designation
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left font-semibold text-slate-900 "
                    >
                      Level as per Pay Matrix
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-slate-200 text-slate-800 overflow-hidden  ">
                  {employeeDetails.length > 0 &&
                    employeeDetails.map((employeeDetailsObj, index) => (
                      <tr key={index}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                          {index + 1}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                          {employeeDetailsObj.name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                          {employeeDetailsObj.designation}
                        </td>
                        <td className=" px-6 py-4 whitespace-nowrap lg:whitespace-normal text-sm">
                          {employeeDetailsObj.levelPayMatrix}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </section>
    </>
  );
}
